import { QueryClient } from '@tanstack/react-query';
import type { AxiosError } from 'axios';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error: unknown) => {
        const status = (error as AxiosError).response?.status;

        return failureCount < 2 && (!status || status >= 500);
      },
      staleTime: 30_000,
    },
    mutations: {
      retry: false,
    },
  },
});
